"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePolicyHolderDetailsSummaryWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordionPlugin_1 = require("../../../components/FalconAccordionPlugin");
var core_1 = require("@athena-portal/core");
var moment = require("moment/moment");
var services_1 = require("@falcon/services");
var SummaryPhoneNumberInput_1 = require("../../../components/annual/SummaryPhoneNumberInput");
var commonFunctions_1 = require("../../../commonFunctions");
var SummaryNameValidateComponent_1 = require("../../../components/annual/SummaryNameValidateComponent");
var Detail = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail" }, children);
};
var DetailKey = function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement("div", { className: "detail-key ".concat(className || "") }, children);
};
var DetailValue = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-value" }, children);
};
var AnnualHomePolicyHolderDetailsSummaryWidget = exports.AnnualHomePolicyHolderDetailsSummaryWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePolicyHolderDetailsSummaryWidget, _super);
    function AnnualHomePolicyHolderDetailsSummaryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchLookupValues = function () {
            var languageCode = "en-UK";
            var valuesToPopulate = [
                {
                    classifier: "maritalStatus",
                    field: _this.policyHolder.maritalStatus,
                    stateName: "maritalStatus"
                },
                {
                    classifier: "employmentStatus",
                    field: _this.policyHolder.employmentStatus,
                    stateName: "employmentStatus"
                },
                {
                    classifier: "wolfOccupation",
                    field: _this.policyHolder.occupation,
                    stateName: "occupation"
                },
                {
                    classifier: "wolfOccupationIndustry",
                    field: _this.policyHolder.occupationIndustry,
                    stateName: "occupationIndustry"
                },
                {
                    classifier: "wolfOccupation",
                    field: _this.policyHolder.secondaryOccupation,
                    stateName: "secondaryOccupation"
                },
                {
                    classifier: "wolfOccupationIndustry",
                    field: _this.policyHolder.secondaryOccupationIndustry,
                    stateName: "secondaryOccupationIndustry"
                }
            ];
            valuesToPopulate.forEach(function (item) {
                var lookupFieldValue = item.field == null ? undefined : item.field;
                _this.lookupService.fetchLookupValues(item.classifier, languageCode, lookupFieldValue).subscribe(function (lookupValues) {
                    var _a;
                    var fetchedLookupItem = lookupValues.find(function (lookupValue) { return lookupValue.id === item.field; });
                    if (fetchedLookupItem) {
                        _this.setState((_a = {}, _a[item.stateName] = fetchedLookupItem.value, _a));
                    }
                });
            });
            if (_this.policyHolder.hasJointPolicyHolder) {
                // joint policyholder
                var jphValuesToPopulate = [
                    {
                        classifier: "employmentStatus",
                        field: _this.jointPolicyHolder.employmentStatus,
                        stateName: "jphEmploymentStatus"
                    },
                    {
                        classifier: "wolfOccupation",
                        field: _this.jointPolicyHolder.occupation,
                        stateName: "jphOccupation"
                    },
                    {
                        classifier: "wolfOccupationIndustry",
                        field: _this.jointPolicyHolder.occupationIndustry,
                        stateName: "jphOccupationIndustry"
                    },
                    {
                        classifier: "wolfOccupation",
                        field: _this.jointPolicyHolder.secondaryOccupation,
                        stateName: "jphSecondaryOccupation"
                    },
                    {
                        classifier: "wolfOccupationIndustry",
                        field: _this.jointPolicyHolder.secondaryOccupationIndustry,
                        stateName: "jphSecondaryOccupationIndustry"
                    },
                ];
                jphValuesToPopulate.forEach(function (item) {
                    _this.lookupService.fetchLookupValues(item.classifier, languageCode).subscribe(function (lookupValues) {
                        var _a;
                        var fetchedLookupItem = lookupValues.find(function (lookupValue) { return lookupValue.id === item.field; });
                        if (fetchedLookupItem) {
                            _this.setState((_a = {}, _a[item.stateName] = fetchedLookupItem.value, _a));
                        }
                    });
                });
            }
        };
        _this.navigateToEditPropertyUsePage = function () {
            _this.props.engine.setJourneyState({
                idToScrollTo: "policyHolderDetailsWidgetId"
            });
            return _this.props.engine.navigate("yourDetails", false);
        };
        _this.policyHolder = _this.props.interaction.policyHolder;
        _this.jointPolicyHolder = _this.props.interaction.jointPolicyHolder;
        _this.expandAccordion = !(0, commonFunctions_1.validatePhoneNumber)(_this.policyHolder.phoneNumber) || !(0, commonFunctions_1.isPolicyHolderNameValid)(_this.policyHolder);
        _this.state = {
            maritalStatus: "",
            employmentStatus: "",
            occupation: "",
            occupationIndustry: "",
            secondaryOccupation: "",
            secondaryOccupationIndustry: "",
            // joint policyholder
            jphEmploymentStatus: "",
            jphOccupation: "",
            jphOccupationIndustry: "",
            jphSecondaryOccupation: "",
            jphSecondaryOccupationIndustry: ""
        };
        return _this;
    }
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues();
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.render = function () {
        return (React.createElement("div", { id: "policyHolderDetailsWidgetId", className: "collapsible-question-panel quote-details-widget" },
            React.createElement(FalconAccordionPlugin_1.FalconAccordion, { togglePositionTop: true, isShown: this.expandAccordion, isShownClassName: "shown", toggleShown: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                    React.createElement("span", null),
                    React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Policyholder details"),
                    React.createElement("span", { className: "toggle-icon collapse-icon" })), toggleHidden: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                    React.createElement("span", null),
                    React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Policyholder details"),
                    React.createElement("span", { className: "toggle-icon expand-icon" })) }, this.renderPolicyHolderDetails())));
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.renderPolicyHolderDetails = function () {
        return (React.createElement("div", { className: "accordion-content grid-make-2-col" },
            React.createElement("img", { className: "home-account-details-image mb-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/account-details.png"), alt: "Account details icon" }),
            React.createElement("div", { className: "section border-0 p-0" },
                React.createElement("div", { className: "section-contents mb-3" },
                    React.createElement(SummaryNameValidateComponent_1.SummaryNameValidateComponent, { policyHolder: this.policyHolder, onStateChange: this.props.onStateChange }),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Date of birth:"),
                        React.createElement(DetailValue, null, moment(this.policyHolder.dateOfBirth, moment.ISO_8601).format("D MMMM YYYY"))),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Employment status:"),
                        React.createElement(DetailValue, null, this.state.employmentStatus)),
                    this.state.occupation.length > 1 &&
                        React.createElement(Detail, null,
                            React.createElement(DetailKey, null, "Occupation:"),
                            React.createElement(DetailValue, null, this.state.occupation)),
                    this.state.occupationIndustry.length > 1 &&
                        React.createElement(Detail, null,
                            React.createElement(DetailKey, null, "Industry:"),
                            React.createElement(DetailValue, null, this.state.occupationIndustry)),
                    this.state.secondaryOccupation.length > 1 &&
                        React.createElement(Detail, null,
                            React.createElement(DetailKey, null, "Secondary occupation:"),
                            React.createElement(DetailValue, null, this.state.secondaryOccupation)),
                    this.state.secondaryOccupationIndustry.length > 1 &&
                        React.createElement(Detail, null,
                            React.createElement(DetailKey, null, "Secondary occupation industry:"),
                            React.createElement(DetailValue, null, this.state.secondaryOccupationIndustry)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Marital status:"),
                        React.createElement(DetailValue, null, this.state.maritalStatus)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Email:"),
                        React.createElement(DetailValue, null, this.policyHolder.email)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Claims in the last 5 years:"),
                        React.createElement(DetailValue, null, this.renderClaimOrNone())),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Criminal convictions:"),
                        React.createElement(DetailValue, null, this.renderUnspentCriminalConvictions())),
                    React.createElement(SummaryPhoneNumberInput_1.SummaryPhoneNumberInput, { phoneNumber: this.policyHolder.phoneNumber, onStateChange: this.props.onStateChange }))),
            this.renderJointPolicyholderIfAvailable(),
            React.createElement("button", { type: "button", className: "btn btn-primary btn-add btn-summary-chapter grid-col-2", onClick: this.navigateToEditPropertyUsePage }, "Edit policyholder(s) details")));
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.renderClaimOrNone = function () {
        var _a;
        return (React.createElement(React.Fragment, null, this.policyHolder.hasClaims && this.policyHolder.numberOfClaims > 0 && ((_a = this.policyHolder.claims) === null || _a === void 0 ? void 0 : _a.length) > 0 ?
            this.renderClaims(this.policyHolder.claims) : 'None'));
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.renderUnspentCriminalConvictions = function () {
        return (React.createElement(React.Fragment, null, this.policyHolder.hasUnspentCriminalConvictions ? 'Yes' : 'No'));
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.renderJointPolicyholderIfAvailable = function () {
        return (React.createElement(React.Fragment, null, this.policyHolder.hasJointPolicyHolder ? this.renderJointPolicyholder() : ''));
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.renderJointPolicyholder = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "dashed-line-separator display-none" }),
            React.createElement("div", { className: "d-flex justify-content-between align-items-center mt-4 grid-col-2 margin-top-48" },
                React.createElement("span", null),
                React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Joint policyholder details"),
                React.createElement("span", null)),
            React.createElement("img", { className: "home-account-details-image mb-2 joint-policyholder", src: "/".concat(services_1.resourcesHelper.THEME, "/img/account-details.png"), alt: "Account details icon" }),
            React.createElement("div", { className: "section border-0 p-0 mb-3" },
                React.createElement("div", { className: "section-contents" },
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null,
                            this.jointPolicyHolder.firstName,
                            " ",
                            this.jointPolicyHolder.lastName)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Date of birth:"),
                        React.createElement(DetailValue, null, moment(this.jointPolicyHolder.dateOfBirth, moment.ISO_8601).format("D MMMM YYYY"))),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Employment status:"),
                        React.createElement(DetailValue, null, this.state.jphEmploymentStatus)),
                    this.state.jphOccupation.length > 1 &&
                        React.createElement(Detail, null,
                            React.createElement(DetailKey, null, "Occupation:"),
                            React.createElement(DetailValue, null, this.state.jphOccupation)),
                    this.state.jphOccupationIndustry.length > 1 &&
                        React.createElement(Detail, null,
                            React.createElement(DetailKey, null, "Industry:"),
                            React.createElement(DetailValue, null, this.state.jphOccupationIndustry)),
                    this.state.jphSecondaryOccupation.length > 1 &&
                        React.createElement(Detail, null,
                            React.createElement(DetailKey, null, "Secondary occupation:"),
                            React.createElement(DetailValue, null, this.state.jphSecondaryOccupation)),
                    this.state.jphSecondaryOccupationIndustry.length > 1 &&
                        React.createElement(Detail, null,
                            React.createElement(DetailKey, null, "Secondary occupation industry:"),
                            React.createElement(DetailValue, null, this.state.jphSecondaryOccupationIndustry)))),
            React.createElement("div", { className: "dashed-line-separator mb-5" })));
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.renderClaims = function (claims) {
        var _this = this;
        return claims.map(function (claim, index) {
            return React.createElement("div", { key: index, className: "detail-value" },
                _this.resolveClaimType(claim.claimType),
                ", ",
                (0, commonFunctions_1.formatDate)(claim.date, "MMM YYYY"));
        });
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.resolveClaimType = function (claimId) {
        var _a, _b;
        var claimTypeNamingList = JSON.parse(sessionStorage.classifier_homeClaimType);
        return (_b = (_a = claimTypeNamingList.find(function (item) { return item.id === claimId; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : this.fetchUnstoredClaimType(claimId);
    };
    AnnualHomePolicyHolderDetailsSummaryWidget.prototype.fetchUnstoredClaimType = function (claimId) {
        var claimType;
        this.lookupService.fetchLookupValues("homeClaimType", "en-UK", claimId)
            .subscribe(function (lookupValues) {
            var _a;
            claimType = (_a = lookupValues.find(function (item) { return item.id === claimId; })) === null || _a === void 0 ? void 0 : _a.value;
        });
        return claimType;
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualHomePolicyHolderDetailsSummaryWidget.prototype, "lookupService", void 0);
    return AnnualHomePolicyHolderDetailsSummaryWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualHomePolicyHolderDetailsSummaryWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomePolicyHolderDetailsSummaryWidget.js
// module id = 3684
// module chunks = 0